import styled from "styled-components";
import Slider from "react-slick";
import { Card } from "react-rainbow-components";
import { Link } from "react-router-dom";
import Footer from "./../Footer";
import MobileHeader from "./../mobile/MobileHeader";
import { useState } from "react";

const AliGashtBlog = () => {
  const [screenSize, setScreenSize] = useState(window.screen.width);

  window.addEventListener("resize", () => {
    setScreenSize(window.screen.width);
  });

  let numberSlide = screenSize > 900 ? 3 : 1;

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: numberSlide,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <Container>
      <MobileHeader />

      <Headers>
        <img src="/images/logo.png" alt="" />
        <h1>aliGasht.ir</h1>
      </Headers>

      <PopularCitis dir="auto">
        <div>
          <h2>شهر های پر تردد</h2>
          <hr />

          <div className="cards">
            <Carousel {...settings}>
              <Wrap>
                <MyCard>
                  <img src="/images/paris2.jpg" alt="" />

                  <h4>پاریس</h4>
                  <p>
                    سفر به پاریس، پایتخت انگلیس، می‌تواند از رویایی‌ترین
                    تجربه‌‌های شما در طول عمرتان باشد. قبل از سفر، حتما راهنمای
                    سفر به این شهر را مطالعه کنید تا آنجا بدون هیچ مشکل و
                    دغدغه‌ای، لحظات نابی تجربه کنید.
                  </p>

                  <Link to="/">ادامه مطلب...</Link>
                </MyCard>
              </Wrap>
              <Wrap>
                <MyCard>
                  <img src="/images/london2.jpg" alt="" />

                  <h4>لندن</h4>
                  <p>
                    سفر به لندن، پایتخت انگلیس، می‌تواند از رویایی‌ترین
                    تجربه‌‌های شما در طول عمرتان باشد. قبل از سفر، حتما راهنمای
                    سفر به این شهر را مطالعه کنید تا آنجا بدون هیچ مشکل و
                    دغدغه‌ای، لحظات نابی تجربه کنید.
                  </p>

                  <Link to="/">ادامه مطلب...</Link>
                </MyCard>
              </Wrap>
              <Wrap>
                <MyCard>
                  <img src="/images/NewYork.jpg" alt="" />

                  <h4>نیویورک</h4>
                  <p>
                    سفر به لندن، پایتخت انگلیس، می‌تواند از رویایی‌ترین
                    تجربه‌‌های شما در طول عمرتان باشد. قبل از سفر، حتما راهنمای
                    سفر به این شهر را مطالعه کنید تا آنجا بدون هیچ مشکل و
                    دغدغه‌ای، لحظات نابی تجربه کنید.
                  </p>

                  <Link to="/">ادامه مطلب...</Link>
                </MyCard>
              </Wrap>
              <Wrap>
                <MyCard>
                  <img src="/images/Kuala Lumpur.jpg" alt="" />

                  <h4>کوالالامپور</h4>
                  <p>
                    سفر به لندن، پایتخت انگلیس، می‌تواند از رویایی‌ترین
                    تجربه‌‌های شما در طول عمرتان باشد. قبل از سفر، حتما راهنمای
                    سفر به این شهر را مطالعه کنید تا آنجا بدون هیچ مشکل و
                    دغدغه‌ای، لحظات نابی تجربه کنید.
                  </p>

                  <Link to="/">ادامه مطلب...</Link>
                </MyCard>
              </Wrap>
              <Wrap>
                <MyCard>
                  <img src="/images/dubai.jpg" alt="" />

                  <h4>دبی</h4>
                  <p>
                    سفر به لندن، پایتخت انگلیس، می‌تواند از رویایی‌ترین
                    تجربه‌‌های شما در طول عمرتان باشد. قبل از سفر، حتما راهنمای
                    سفر به این شهر را مطالعه کنید تا آنجا بدون هیچ مشکل و
                    دغدغه‌ای، لحظات نابی تجربه کنید.
                  </p>

                  <Link to="/">ادامه مطلب...</Link>
                </MyCard>
              </Wrap>
            </Carousel>
          </div>
        </div>
      </PopularCitis>

      <VisaLess dir="auto">
        <h2>مرتبط با شما</h2>
        <hr />

        <div className="cards">
          <MyCard>
            <img src="/images/visa.jpg" alt="" />

            <h4>سفر به کشور های بدون ویزا</h4>

            <p>
              اگر تصمیم به سفر و سپری کردن تابستانی به یاد ماندنی دارید اما محل
              سفر خود را تعیین نکرده اید و افدامی برای اخذ ویزا نکرده اید
              میتوانید تابستان به یاد ماندنی ای با سفر به کشور های بدون ویزا
              برای ایرانیان رقم بزنید.
            </p>

            <Link to="/"> ادامه مطلب ...</Link>
          </MyCard>

          <MyCard>
            <img src="/images/hotelRoom.jpg" alt="" />

            <h4>اصطلاحات مربوط به هتل </h4>
            <p>
              اتاق های کابانا یا کانکت چیست؟ چه اصطلاحاتی درباره هتل ها باید در
              سفر های داخلی و خارجی را بدانیم؟ برای آشنایی با انواع اصطلاحات
              اتاق ها و تخت های هتل ها با ما همراه باشید...
            </p>

            <Link to="/">ادامه مطلب...</Link>
          </MyCard>

          <MyCard>
            <img src="/images/ecocamp.jpg" alt="" />

            <h4>اکوکمپ چیست؟</h4>

            <p>
              اکو کمپ یک اقامتگاه موقت و یک مقصد گردشگری در مناطق بکر طبیعی است
              که تمام خدمات آن با محیط زیست منطقه و استانداردهای بین‌المللی،
              هماهنگی دارد؛ به بیان دیگر...
            </p>

            <Link to="/">ادامه مطلب ...</Link>
          </MyCard>
        </div>
      </VisaLess>

      <Footer />
    </Container>
  );
};

export default AliGashtBlog;

const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;

  .world {
    height: 400px;
  }
`;

const Headers = styled.div`
  height: 50px;
  background-color: #e73511;
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    width: 100vw;
  }
`;

const Carousel = styled(Slider)`
  margin: 20px auto 0 auto;
  width: 100%;

  .slick-next {
    height: 100%;
    right: -60px;
    z-index: 1;
    opacity: 0;
    display: none;

    /* &:hover {
      opacity: 1;
    } */
  }
  .slick-prev {
    height: 100%;
    width: 5vw;
    left: -60px;
    z-index: 1;
    display: none !important;

    /* 
    &:hover {
      opacity: 1;
    } */
  }
  .slick-list {
    overflow: initial;

    @media (max-width: 900px) {
      overflow: hidden;
    }
  }
  .slick-dots li,
  .slick-dots li button::before {
    font-size: 40px;
    color: #939ba7;
  }
`;

const Wrap = styled.div`
  position: relative;
  cursor: pointer;
  border-radius: 4px;

  a {
    border-radius: 4px;
    position: relative;
    display: block;
    padding: 4px;

    img {
      width: 100%;
      height: 400px;
      border-radius: 10px;
    }

    &:hover {
      padding: 0;
      border: 4px solid #c9c9cb;
      transition-duration: 300ms;
    }
  }
`;

const PopularCitis = styled.div`
  position: relative;
  width: 100vw;
  background-image: url("/images/world.jpg");
  background-position: center;

  & > div {
    position: relative;
    z-index: 2;
    width: 90vw;
    margin: 0 auto 0 auto;
    h2 {
      padding: 5px 10px;
      color: #202020;
    }

    .cards {
      display: flex;
      justify-content: space-between;
    }
  }

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #ffffffb2;
  }
`;

const MyCard = styled(Card)`
  width: 350px;
  margin-top: 20px;
  padding-bottom: 15px;
  direction: rtl;
  @media (max-width: 900px) {
    width: 95%;
  }

  img {
    max-width: 100%;
    height: 250px;
  }

  h4 {
    font-size: 17px;
    padding: 5px 50px;
  }

  p {
    padding: 0 50px;
    text-align: justify;
  }

  a {
    display: block;
    text-decoration: none;
    text-align: left;
    color: #202020;
    padding: 5px 30px;
  }
`;

const VisaLess = styled.div`
  width: 90vw;
  margin: 80px auto 40px auto;

  .cards {
    display: flex;
    justify-content: space-between;

    @media (max-width: 900px) {
      flex-direction: column;
    }
  }

  h4 {
    font-size: 17px;
    padding: 5px 30px;
  }

  p {
    padding: 0 30px;
    text-align: justify;
  }

  a {
    display: block;
    text-decoration: none;
    text-align: left;
    color: #202020;
    padding: 5px 30px;
  }
`;
